import React from 'react'
import PropTypes from 'prop-types'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom'
import IdleTimer from 'react-idle-timer'
import auth from '../auth'
import './App.css'
import '../assets/css/index.css'

import {
  Login,
  LoginResetPasswordRequest,
  LoginCreatePassword,
  UnsupportedBrowser,
  RedirectNotice
} from './'

import {
  Application
} from '../components'

import {
  TIMEOUT_MINS
} from '../constants'

export default class App extends React.Component {
  static propTypes = {
    children: PropTypes.any
  }

  constructor(props) {
    super(props)

    this.idleTimer = null
  }

  isUserUsingChromeBrowser = () => {
    // https://stackoverflow.com/questions/4565112/javascript-how-to-find-out-if-the-user-browser-is-chrome/13348618#13348618
    // please note (last edit 29 Aug 2017),
    // that IE11 now returns undefined again for window.chrome
    // and new Opera 30 outputs true for window.chrome
    // and new IE Edge outputs to true now for window.chrome
    // and if not iOS Chrome check
    // so use the below updated condition
    const isChromium = window.chrome
    const winNav = window.navigator
    const vendorName = winNav.vendor
    const isOpera = typeof window.opr !== "undefined"
    const isIEedge = winNav.userAgent.indexOf("Edge") > -1
    const isIOSChrome = winNav.userAgent.match("CriOS")

    if (isIOSChrome) {  // is Google Chrome on IOS
      return true
    } else if (
      isChromium !== null &&
      typeof isChromium !== "undefined" &&
      vendorName === 'Google Inc.' &&
      isOpera === false &&
      isIEedge === false
    ) {
      return true
    } else {
      return false
    }
  }

  logout = (e) => auth.logout()

  render() {
    return (
      <Router>
        <Switch>
          <Route exact path='/' render={() => (
            <Redirect
              push
              to='/login'
            />)}
          />
          <Route exact path='/login' render={({ location }) => {
            localStorage.clear()
            return this.isUserUsingChromeBrowser()
              ? <Login location={location} />
              : <Redirect to='/unsupported' />
            }}
          />
          <Route exact path='/password/reset' component={LoginResetPasswordRequest} />
          <Route exact path='/password/reset/confirm/:uid/:token/' component={LoginCreatePassword} />
          <Route exact path='/unsupported' component={UnsupportedBrowser} />
          <Route exact path='/redirect' component={RedirectNotice} />
          <Route render={() => (
              <IdleTimer
                ref={ref => { this.idleTimer = ref }}
                element={document}
                onIdle={this.logout}  // logout after time of user inactivity equals the amount of timeout mins specified (TIMEOUT_MINS)
                timeout={1000 * 60 * TIMEOUT_MINS}>
                <Application />
              </IdleTimer>
            )}
          />
        </Switch>
      </Router>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/App.js